import { fetchData } from "app/services/apiService";

export const getListaAllegati = (gruppo) => {
    //l'IDStruttura viene preso dirtamente lato backend
    const apiUrl = `pdf/GetListaAllegati/${gruppo}`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };
}

export const generaPDF = (request) => {
    //l'IDStruttura viene preso dirtamente lato backend
    const apiUrl = `pdf/GeneraPDfDaAllegato`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl, request, null, "POST"))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };
}